import { RouterType } from '@online-webinar/router';
import { LiveParticipants } from '@online-webinar/webinar-management';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/$webinarId/live-participants'].update({
        staticData: { title: { page: 'Insights.Live.PageHeading', forWebinar: true } },
        component: authGuard(LiveParticipants, { canBroadcast: true })
    });
};
